import PropTypes from 'prop-types'

export default {

  /**
   * Если true включается анимация ожидания
   */
  loading: PropTypes.bool,

  size: PropTypes.number

}
